var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist';
import { getDepositShareSums, getBillingVoucherIdsFromDepositShare, DepositShareType, } from '@debbie/common/dist/economy/billing/organize';
import { VoucherCategory, } from '@debbie/common/dist/economy/vouchers';
import { objectBy } from '@debbie/common/dist/util';
import * as billingAPI from '@debbie/cortex/dist/api/billing';
import * as billingVouchersAPI from '@debbie/cortex/dist/api/billing-vouchers';
import { billingCollectionsKey, ongoingWorkBillingKey, ongoingWorkKey, } from '@debbie/cortex/dist/billings';
import q from '@debbie/cortex/dist/query';
import { Badge, Button, ButtonGroup, CasePreview, Modal, Money, PlaceholderLoader, Timestamp, } from '..';
import THEME from '../../theme';
import { powerTableEconomicalValues } from '../economy/billing-table-utils';
import PaymentTypeComponent from '../economy/case-vouchers/PaymentType';
import DepositShareComponent from '../economy/DepositShare';
import PowerTable, { FilterType } from '../PowerTable';
var BillingRowType;
(function (BillingRowType) {
    BillingRowType["Deposit"] = "Deposit";
})(BillingRowType || (BillingRowType = {}));
const UIPreview = (props) => {
    const { billing } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [loadingBilling, setLoadingBilling] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);
    const [selected, setSelected] = React.useState([]);
    const [depositSharePreview, setDepositSharePreview] = React.useState(null);
    const billingRows = billing && transformBillingToRows(billing, lang);
    return (React.createElement("div", null, billingRows ? (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { fontSize: '0.8em' } },
            React.createElement(PowerTable, { data: billingRows, genKey: (row) => row.key, searchable: true, toSearchStr: (br) => {
                    var _a, _b, _c, _d;
                    return `${(_a = br.text) !== null && _a !== void 0 ? _a : ''} ${(_b = br.caseSequentialId) !== null && _b !== void 0 ? _b : ''} ${(_c = br.customerReferenceId) !== null && _c !== void 0 ? _c : ''} ${(_d = br.sequentialId) !== null && _d !== void 0 ? _d : ''} ${br.type}`;
                }, selectable: true, selectKey: (row) => row.key, selected: selected, defaultSortKey: "date", onSelect: setSelected, onClick: (row) => {
                    if (row.key.indexOf(BillingRowType.Deposit) !== -1) {
                        const depositShare = billing.depositShare.find((depositShare) => {
                            var _a;
                            return row.key.indexOf(((_a = depositShare.deposit) === null || _a === void 0 ? void 0 : _a.caseVoucherId) || '') !== -1 && row.key.indexOf(depositShare.type) !== -1;
                        });
                        if (depositShare) {
                            setDepositSharePreview(depositShare);
                        }
                    }
                }, pagination: {
                    type: 'pages',
                    pageSize: 50,
                }, values: Object.assign({ sequentialId: {
                        label: lang.billing.billingSequentialId,
                        // @ts-ignore
                        map: (id) => id,
                    }, caseSequentialId: {
                        label: lang.billing.case,
                        // @ts-ignore
                        map: (caseSequentialId) => caseSequentialId ? (React.createElement(CasePreview, { caseId: caseSequentialId })) : undefined,
                    }, date: {
                        label: lang.billing.date,
                        map: (date) => {
                            return date && React.createElement(Timestamp, { date: date });
                        },
                        align: 'right',
                        filter: {
                            type: FilterType.DateRange,
                        },
                    }, type: {
                        label: lang.billing.type,
                        toCmp: (type) => type,
                        map: (type, row) => {
                            return (React.createElement("div", { style: {
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }, title: type },
                                React.createElement("b", null, type),
                                ' ',
                                row.depositShareType === DepositShareType.Deposit && (React.createElement("span", null,
                                    row.paymentType && (React.createElement(PaymentTypeComponent, { paymentType: row.paymentType })),
                                    ' ',
                                    row.depositState &&
                                        lang.caseVoucherStates[row.depositState]))));
                        },
                        filter: {
                            type: FilterType.Category,
                            categories: objectBy(billingRows.map(({ type }) => ({ label: type, type })), ({ type }) => type),
                        },
                    }, text: {
                        label: lang.billing.text,
                        // @ts-ignore
                        map: (text) => text ? (React.createElement("div", { style: {
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }, title: text }, text)) : null,
                    }, customerReferenceId: {
                        label: lang.billing.customerReferenceId,
                        // @ts-ignore
                        map: (id) => id,
                    }, deposits: {
                        label: lang.billing.deposit,
                        align: 'right',
                        toCmp: (deposits) => deposits,
                        map: (deposits) => React.createElement(Money, { amount: deposits }),
                        filter: {
                            type: FilterType.MoneyRange,
                        },
                    } }, powerTableEconomicalValues({
                    lang,
                })) })),
        depositSharePreview && (React.createElement(Modal, { maxWidth: "700px", onToggle: () => setDepositSharePreview(null) },
            React.createElement(DepositShareComponent, { depositShare: depositSharePreview, billingSelector: props.billingSelector }))),
        React.createElement("br", null),
        React.createElement(ButtonGroup, null,
            props.billingSelector && site === Site.Caseworker && (React.createElement(Button, { size: "small", loading: loadingBilling, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    if (props.billingSelector) {
                        setLoadingBilling(true);
                        try {
                            const billingVoucherIds = selected.length
                                ? {
                                    billingVoucherIds: getSelectedBillingVoucherIds(billingRows, selected, billing),
                                }
                                : {};
                            yield billingAPI.createBillingCollection({
                                newBillings: [
                                    Object.assign(Object.assign({}, props.billingSelector), billingVoucherIds),
                                ],
                            });
                            setSelected([]);
                            q.invalidate([
                                ongoingWorkBillingKey(props.billingSelector),
                                billingCollectionsKey(),
                                ongoingWorkKey(),
                            ]);
                            if (props.closeModal) {
                                props.closeModal();
                            }
                        }
                        catch (error) {
                            console.error(error);
                            alert('Error');
                        }
                        setLoadingBilling(false);
                    }
                }) },
                lang.billing.bill,
                ' ',
                !!selected.length && (React.createElement(Badge, { style: { color: THEME.COLOR_ACCENT }, theme: THEME.COLOR_SECONDARY }, selected.length)))),
            props.billingSelector && (React.createElement(Button, { size: "small", loading: deleting, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    setDeleting(true);
                    if (confirm(lang.billing.deleteApproval)) {
                        try {
                            yield billingVouchersAPI.del(selected.length === 0
                                ? billing.billingVouchers.map((billingVoucher) => billingVoucher.billingVoucherId)
                                : getSelectedBillingVoucherIds(billingRows, selected, billing));
                            setSelected([]);
                            q.invalidate([billingCollectionsKey(), ongoingWorkKey()]);
                            if (props.billingSelector) {
                                q.invalidate([
                                    ongoingWorkBillingKey(props.billingSelector),
                                ]);
                            }
                            if (props.closeModal) {
                                props.closeModal();
                            }
                        }
                        catch (error) {
                            console.error(error);
                            alert('Error');
                        }
                    }
                    setDeleting(false);
                }), theme: "dangerous" },
                lang.billing.delete,
                ' ',
                !!selected.length && (React.createElement(Badge, { style: { color: THEME.COLOR_ACCENT }, theme: THEME.COLOR_SECONDARY }, selected.length))))))) : (React.createElement(PlaceholderLoader, null))));
};
const getSelectedBillingVoucherIds = (billingRows, selected, billing) => selected
    ? selected
        .map((key) => {
        const row = billingRows.find((row) => row.key === key);
        if (!row) {
            console.log(key);
            throw new Error('Could not find billing row');
        }
        return row.billingVoucherIds;
    })
        .reduce((acc, arr) => acc.concat(arr), [])
    : billing.billingVouchers.map((billingVoucher) => billingVoucher.billingVoucherId);
const mapBillingVoucherToRow = (lang) => (billingVoucher) => {
    var _a, _b;
    const revenue = [
        VoucherCategory.COLLECTIONCOMMISSION,
        VoucherCategory.FEE,
    ].includes(billingVoucher.category)
        ? billingVoucher.amount
        : 0;
    const disbursements = billingVoucher.category === VoucherCategory.DISBURSEMENT
        ? billingVoucher.amount
        : 0;
    const vat = 
    // @ts-ignore
    (billingVoucher.vat
        ? // @ts-ignore
            billingVoucher.vat.reduce((acc, billingVoucher) => acc + billingVoucher.amount, 0)
        : 0) +
        (billingVoucher.category === VoucherCategory.VAT
            ? billingVoucher.amount
            : 0);
    return {
        key: billingVoucher.billingVoucherId,
        type: lang.economyVoucherTypeLabels[billingVoucher.voucherTypeId] || billingVoucher.label,
        date: billingVoucher.date,
        caseSequentialId: (_a = billingVoucher.info) === null || _a === void 0 ? void 0 : _a.caseSequentialId,
        customerReferenceId: (_b = billingVoucher.info) === null || _b === void 0 ? void 0 : _b.customerReferenceId,
        text: billingVoucher.text,
        sequentialId: billingVoucher.id,
        billingVoucherIds: [billingVoucher.billingVoucherId].concat(
        // @ts-ignore
        (billingVoucher.vat || []).map((vatBillingVoucher) => vatBillingVoucher.billingVoucherId)),
        deposits: 0,
        revenue,
        disbursements,
        vat,
        balance: revenue + vat + disbursements,
        payout: 0,
        overpayments: 0,
    };
};
const transformBillingToRows = (billing, lang) => {
    let rows = [];
    // Concat deposit share
    rows = rows.concat(billing.depositShare.map((depositShare) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const { collectionCommission, vat, balance, payout, overpayment, deposit, } = getDepositShareSums(depositShare);
        const billingVoucherIds = getBillingVoucherIdsFromDepositShare(depositShare);
        return {
            key: `${BillingRowType.Deposit}${((_a = depositShare.deposit) === null || _a === void 0 ? void 0 : _a.caseVoucherId) || billingVoucherIds.join(',')}${depositShare.type}`,
            type: lang.depositShareType[depositShare.type],
            date: (_b = depositShare.deposit) === null || _b === void 0 ? void 0 : _b.date,
            sequentialId: (_c = depositShare.deposit) === null || _c === void 0 ? void 0 : _c.id,
            caseSequentialId: (_d = depositShare.info) === null || _d === void 0 ? void 0 : _d.caseSequentialId,
            customerReferenceId: (_e = depositShare.info) === null || _e === void 0 ? void 0 : _e.customerReferenceId,
            depositState: (_f = depositShare.deposit) === null || _f === void 0 ? void 0 : _f.state,
            depositShareType: depositShare.type,
            deposits: deposit,
            revenue: collectionCommission,
            vat,
            balance,
            payout,
            disbursements: 0,
            overpayments: overpayment,
            paymentType: (_g = depositShare.deposit) === null || _g === void 0 ? void 0 : _g.paymentType,
            billingVoucherIds: billingVoucherIds,
        };
    }));
    // Concat fees
    rows = rows.concat(billing.fees.map(mapBillingVoucherToRow(lang)));
    // Concat disbursements
    rows = rows.concat(billing.disbursements.map(mapBillingVoucherToRow(lang)));
    // Concat vat
    rows = rows.concat(billing.vat.map(mapBillingVoucherToRow(lang)));
    return rows;
};
export default UIPreview;
//# sourceMappingURL=UIPreview.js.map